(function () {
  'use strict';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function setText(node, value) {
    if (node && value) node.textContent = value;
  }

  function replaceExact(root) {
    var replacements = {
      'PRØVET I HVERDAGEN': 'JESPERS VURDERING',
      'Prøvet i hverdagen': 'Jespers vurdering',
      'Det skal være lettere at vælge rigtigt': 'God til én opgave. Ikke til alle.',
      'Her samler vi den konkrete vurdering: hvad produktet gør godt, hvordan det er prøvet, og hvornår du bør vælge noget andet.': 'Læs hvorfor produktet er med, hvad du skal kontrollere før køb, og hvornår jeg ville vælge en anden løsning.',
      'UDVALGT EFTER FUNKTION': 'PÅ LAGER NU',
      'Udvalgt efter funktion': 'På lager nu',
      'Knivpleje og opbevaring til daglig brug': 'Redskaber til skarpe knive og bedre opbevaring',
      'Se pris, lagerstatus og den konkrete forskel mellem hurtig slibning, slibesten og opbevaring. Kun varer på lager vises her.': 'Slibesten, pleje og magnetisk opbevaring, som kan bestilles nu. Pris og lagerstatus står på hvert produkt.',
      'Swipe dig gennem det vigtigste': 'Se om produktet passer til din opgave',
      'Billeder og korte svar først. Den fulde forklaring ligger samlet længere nede.': 'Brug, mål, begrænsninger og alternativer - ét kort ad gangen.',
      'Forstå produktet på få sekunder': 'Hvad løser produktet?',
      'Det vigtigste': 'Kort fortalt',
      'Vælg rigtigt': 'Passer det til dig?',
      'Er det den rigtige løsning?': 'Passer det til din opgave?',
      'Fakta før køb': 'Specifikationer',
      'Den ærlige begrænsning': 'Begrænsning',
      'Det skal du kende på forhånd': 'Det skal du kontrollere før køb',
      'Har du set nok?': 'Vil du købe produktet?',
      'Fold kun det ud, du vil vide mere om': 'Vurdering, mål og begrænsninger',
      'Vurdering, brug, materialer og pleje er samlet her, så produktsiden ikke bliver en væg af tekst.': 'Se hvad produktet er godt til, hvad du skal kontrollere, og hvornår en anden løsning passer bedre.',
      'Andre løsninger til den samme opgave': 'Hvad er forskellen - og hvad passer bedst?',
      'Se forskellen på metode, størrelse, materiale, pris og lagerstatus. Produkterne er valgt, fordi de løser en lignende opgave - ikke bare fordi de ligger i samme shop.': 'Sammenlign metode, størrelse, materiale, pris og lager. Produkterne løser samme type opgave på forskellige måder.',
      'Foretrækker du stadig denne?': 'Vil du købe dette produkt?',
      'Læg denne i kurv': 'Gå til pris og køb',
      'Valgbare tilkøb': 'Relevante tilkøb',
      'Det giver mening sammen': 'Kun hvis du mangler det',
      'Vælg kun det, du får brug for. Lager og pris opdateres direkte fra Shopify.': 'Hvert tilkøb løser en konkret opgave sammen med hovedproduktet. Intet er valgt på forhånd.',
      'Dit udgangspunkt': 'Valgt produkt',
      'Klar til at vælge?': 'På lager',
      'Produktet kan bestilles lige nu. Brug knappen herunder for at gå tilbage til variantvalg, den aktuelle pris og købsknappen.': 'Gå tilbage til pris og variantvalg, og læg produktet i kurven.',
      'Du har set brug, fakta, alternativer og tilkøb. Herfra er næste skridt enkelt.': 'Pris, variant og lagerstatus står samlet ved købsknappen.',
      'Det her kan komme hjem til dig nu': 'Redskaber til skarpe knive og bedre opbevaring',
      'Her viser vi kun varer, der kan bestilles nu. Klik ind for at se, hvad de passer til, og hvornår du bør vælge noget andet.': 'Slibesten, pleje og magnetisk opbevaring, som kan bestilles nu. Pris og lagerstatus står på hvert produkt.',
      'Hvad står du med lige nu?': 'Hvad vil du have løst?',
      'Vælg det, der irriterer eller mangler. Så får du den korte vej videre.': 'Sløv kniv, slibesten, opbevaring eller gave - vælg den situation, du står i.',
      'Start med situationen': 'Vælg efter problemet'
    };

    root.querySelectorAll('span,h1,h2,h3,p,a,button,strong,small,dt,dd,li').forEach(function (node) {
      if (node.children.length > 0) return;
      var key = clean(node.textContent);
      if (Object.prototype.hasOwnProperty.call(replacements, key)) {
        node.textContent = replacements[key];
      }
    });
  }

  function refineHome(root) {
    var products = root.querySelector('.ln10-products');
    if (products) {
      setText(products.querySelector('.ln10-eyebrow'), 'På lager nu');
      setText(products.querySelector('.ln10-section-head h2'), 'Redskaber til skarpe knive og bedre opbevaring');
      setText(products.querySelector('.ln10-section-head .ln10-lead'), 'Slibesten, pleje og magnetisk opbevaring, som kan bestilles nu. Pris og lagerstatus står på hvert produkt.');
      setText(products.querySelector('.ln10-section-head .ln10-link'), 'Se alt på lager');
    }

    var needs = root.querySelector('.lnsales-needs__head');
    if (needs) {
      setText(needs.querySelector('.ln10-eyebrow'), 'Vælg efter problemet');
      setText(needs.querySelector('h2'), 'Hvad vil du have løst?');
      setText(needs.querySelector('p'), 'Sløv kniv, slibesten, opbevaring eller gave - vælg den situation, du står i.');
    }
  }

  function refineProduct(root) {
    var details = root.querySelector('.ln-details__header');
    if (details) {
      setText(details.querySelector('.eyebrow'), 'Før du køber');
      setText(details.querySelector('h2'), 'Brug, materialer og svar');
      setText(details.querySelector('p'), 'Find oplysninger om vedligeholdelse, mål og valg af produkt.');
    }

    var comparison = root.querySelector('.ln-product-compare__header');
    if (comparison) {
      setText(comparison.querySelector('.eyebrow'), 'Sammenlign alternativer');
      setText(comparison.querySelector('h2'), 'Hvad er forskellen - og hvad passer bedst?');
      setText(comparison.querySelector('p'), 'Sammenlign metode, størrelse, materiale, pris og lager. Produkterne løser samme type opgave på forskellige måder.');
    }

    var related = root.querySelector('.ln-buy-together__header');
    if (related) {
      setText(related.querySelector('.eyebrow'), 'Relevante tilkøb');
      setText(related.querySelector('h2'), 'Kun hvis du mangler det');
      setText(related.querySelector('p'), 'Hvert tilkøb løser en konkret opgave sammen med hovedproduktet. Intet er valgt på forhånd.');
    }

    root.querySelectorAll('[data-ln-placement="comparison_footer"],[data-ln-placement="feed_footer"]').forEach(function (button) {
      setText(button, 'Gå til pris og køb');
    });

    var finalBuy = root.querySelector('.ln-final-buy');
    if (finalBuy && finalBuy.querySelector('[data-ln-jump-buy]')) {
      setText(finalBuy.querySelector('.eyebrow'), 'På lager');
      var title = finalBuy.querySelector('h2');
      if (title && clean(title.textContent).indexOf('Køb ') !== 0) {
        title.textContent = 'Køb ' + clean(title.textContent);
      }
      setText(finalBuy.querySelector('p'), 'Gå tilbage til pris og variantvalg, og læg produktet i kurven.');
      setText(finalBuy.querySelector('[data-ln-jump-buy]'), 'Gå til pris og køb');
    }

    var fullFinal = root.querySelector('.ln-product-final-buy__copy');
    if (fullFinal) {
      var available = root.querySelector('[data-ln-final-buy]') && root.querySelector('[data-ln-final-buy]').querySelector('[data-ln-final-add]');
      if (available) {
        setText(fullFinal.querySelector('.eyebrow'), 'På lager');
        setText(fullFinal.querySelector('h2'), 'Køb produktet');
        setText(fullFinal.querySelector('p'), 'Pris, variant og lagerstatus står samlet ved købsknappen.');
      }
    }

    var trustRows = root.querySelectorAll('.ln-ptrust__item');
    if (trustRows.length >= 4) {
      setText(trustRows[0].querySelector('small'), 'Pakket og sendt fra Tørring');
      setText(trustRows[1].querySelector('small'), 'Gælder ved varekøb på mindst 599 kr.');
      setText(trustRows[2].querySelector('small'), 'Se vilkår og fremgangsmåde');
      setText(trustRows[3].querySelector('small'), 'Betalingsoplysninger håndteres i checkout');
    }
  }

  function refineTrust(root) {
    var rows = root.querySelectorAll('.ln10-trust article');
    if (rows.length >= 4) {
      setText(rows[0].querySelector('p'), 'Gælder ved varekøb på mindst 599 kr.');
      setText(rows[1].querySelector('p'), 'Pakket og sendt fra Tørring');
      setText(rows[2].querySelector('p'), 'Se vilkår og fremgangsmåde');
      setText(rows[3].querySelector('p'), 'Betalingsoplysninger håndteres i checkout');
    }
  }

  function apply(root) {
    var scope = root || document;
    replaceExact(scope);
    refineHome(scope);
    refineProduct(scope);
    refineTrust(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    apply(event.target);
  });
}());

